<script lang="ts">
  import {ChooseTemplate, Preview, Renderer, SelectSubtitles, Test, ThumbPreview, UnderMaintenance} from '@/pages';
  import AdminPage from '@/pages/admin/AdminPage.svelte';
  import Analytics from '@/pages/admin/analytics/Analytics.svelte';
  import ChooseVideoRedesign from '@/pages/choose-video-redesign/ChooseVideoRedesign.svelte';
  import HighlightRecapSubtitles from '@/pages/highlight-recap-subtitles/HighlightRecapSubtitles.svelte';
  import HelpForm from '@/pages/settings/HelpForm.svelte';
  import ThumbnailTemplate from '@/pages/thumbnail/ThumbnailTemplate.svelte';
  import {isMobile, menu, step} from '@/store';
  import {MENU, STEP} from '@/types/common';
  import BrandkitPage from '../../pages/user-settings/BrandkitPage.svelte';
  import {mobileAndTabletCheck} from '../../utils/common';
  // const isAdmin = window.uData && window.uData.isAdmin;
  import RecapPreview from '@/pages/recap-preview/RecapPreview.svelte';
  import SelectIntro from '@/pages/select-intro/SelectIntro.svelte';
  import EventsModule from '@/services/events/EventsModule.svelte';
  // let isMobile = mobileAndTabletCheck();
</script>

<svelte:window on:resize={() => isMobile.set(mobileAndTabletCheck())} />

<EventsModule />
<!-- {#if $isMobile && !$user.isAdmin}
<div class="h-full w-full absolute top-0 left-0 bg-white">
    <div class="p-6 rounded-sm mx-auto my-auto justify-center">

        <span class="text-4xl block mb-4 font-bold w-full text-center"
        >Sorry!</span>
        <span class="text-xl w-full block text-gray-500 text-center"
        >Sermon Shots is currently not available on mobile.</span>
    </div>
</div>
{:else} -->
{#if $step === STEP.CHOOSE_VIDEO}
  <ChooseVideoRedesign /> <!-- Test -->
{:else if $step === STEP.HIGHLIGHT_SUBTITLE}
  <HighlightRecapSubtitles />
{:else if $step === STEP.CHOOSE_TEMPLATE}
  {#if $menu === MENU.THUMBNAILS}
    <ThumbnailTemplate />
  {:else}
    <ChooseTemplate />
  {/if}
{:else if $step === STEP.SELECT_SUBTITLES}
  <SelectSubtitles />
{:else if $step === STEP.PREVIEW}
  {#if $menu === MENU.THUMBNAILS}
    <ThumbPreview />
  {:else}
    <Preview />
  {/if}
{:else if $step === STEP.SELECT_INTRO}
  <SelectIntro />
{:else if $step === STEP.RECAP_PREVIEW}
  <RecapPreview />
{:else if $step === STEP.RENDER}
  <Renderer />
{:else if $step === STEP.TEST}
  <Test />
{:else if $step === STEP.SETTINGS}
  <HelpForm />
{:else if $step === STEP.MAINTENANCE}
  <UnderMaintenance />
{:else if $step === STEP.ADMIN}
  <AdminPage />
{:else if $step === STEP.ANALYTICS}
  <Analytics />
{:else if $step === STEP.BRANDKIT}
  <BrandkitPage />
{/if}
<!-- {/if} -->
